export function getPathLengthAtPoint(path, point) {
  const totalLength = path.getTotalLength()
  const samples = Math.max(32, Math.ceil(totalLength / 2))
  let closestLength = 0
  let closestDistance = Infinity

  for (let index = 0; index <= samples; index++) {
    const length = totalLength * index / samples
    const position = path.getPointAtLength(length)
    const distance = (position.x - point[0]) ** 2 + (position.y - point[1]) ** 2
    if (distance < closestDistance) {
      closestDistance = distance
      closestLength = length
    }
  }

  let left = Math.max(0, closestLength - totalLength / samples)
  let right = Math.min(totalLength, closestLength + totalLength / samples)
  for (let index = 0; index < 12; index++) {
    const first = left + (right - left) / 3
    const second = right - (right - left) / 3
    const firstPoint = path.getPointAtLength(first)
    const secondPoint = path.getPointAtLength(second)
    const firstDistance = (firstPoint.x - point[0]) ** 2 + (firstPoint.y - point[1]) ** 2
    const secondDistance = (secondPoint.x - point[0]) ** 2 + (secondPoint.y - point[1]) ** 2
    if (firstDistance < secondDistance) right = second
    else left = first
  }
  return (left + right) / 2
}

export function getStoryProgress(story, sections) {
  if (!story || !sections.length) return 1
  const scrollTop = story.scrollTop
  // The first station must remain the starting point even when a tall
  // viewport already extends beyond the first section's center.
  const stops = sections.map(section => Math.max(0,
    section.offsetTop + section.offsetHeight * 0.5 - story.clientHeight * 0.5
  ))
  if (scrollTop <= stops[0]) return 1

  for (let index = 0; index < stops.length - 1; index++) {
    if (scrollTop <= stops[index + 1]) {
      const fraction = (scrollTop - stops[index]) / (stops[index + 1] - stops[index] || 1)
      // Hold at each station while its text is being read. Only the middle
      // 40% of the distance between sections moves the marker along the rail.
      const transitionStart = 0.3
      const transitionEnd = 0.7
      const progress = (fraction - transitionStart) / (transitionEnd - transitionStart)
      return index + 1 + Math.max(0, Math.min(1, progress))
    }
  }

  return sections.length
}
